import { useEffect, useMemo, useState } from "react";
import { Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../../Components/Common/DeleteModal";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";
import Loader from "../../../Components/Common/Loader";
import {
  useCollaborators,
  useDeleteCollaborator,
} from "../../../hooks/useCollaborators";

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const Collaborateurs = (props) => {
  const { t } = props;
  const { data: collaborateurs = [], isLoading, error } = useCollaborators();
  const deleteCollaboratorMutation = useDeleteCollaborator();

  useEffect(() => {
    document.title = t("Liste des collaborateurs");
  }, [t]);

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [collaborateur, setCollaborateur] = useState(null);

  const onClickDelete = (collaborateurItem) => {
    setCollaborateur(collaborateurItem);
    setDeleteModal(true);
  };

  const handleDeleteCollaborator = () => {
    if (collaborateur && collaborateur.id) {
      deleteCollaboratorMutation.mutate(collaborateur.id, {
        onSuccess: () => {
          setDeleteModal(false);
          setCollaborateur(null);
        },
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((_) => {
      del.style.display = "none";
    });
  };

  const typeCollabLabel = (value) => {
    switch (value) {
      case "assistant":
        return "Assistant";
      case "commite":
        return "Commité";
      case "admin":
        return "Admin";
      default:
        return value || " ";
    }
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },

      {
        Header: t("IDENTIFIANT"),
        accessor: "username",
        Cell: (article) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 italic"
                  style={{ fontWeight: "bold" }}
                >
                  <Link
                    to={`/collaborateurs-details/${article.row.original.id}`}
                    className="text-black"
                  >
                    {" "}
                    {article.row.original.username}
                  </Link>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: t("EMAIL"),
        accessor: "email",
        Cell: (article) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 ">
                  <span>{article.row.original.email}</span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: t("TEL"),
        accessor: "phone_number",
        Cell: (article) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 ">
                  <Link
                    to={`/#/${article.row.original.id}/`}
                    className="text-dark"
                  ></Link>
                  {article.row.original.phone_number}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: t("Collaborateur"),
        Cell: (article) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1"
                  style={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    textAlign: "center",
                  }}
                >
                  <Link
                    to={`/#/${article.row.original.id}/`}
                    className="text-dark"
                  ></Link>
                  <span className="badge badge-soft-warning me-1">
                    {typeCollabLabel(article.row.original.type_collab)}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },

      {
        Header: "Action",
        Cell: (cellProps) => {
          const articlesData = cellProps.row.original;
          return (
            <>
              <li className="list-inline-item" title={t("Voir")}>
                <Link
                  to={`/collaborateurs-details/${articlesData.id}`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              <li className="list-inline-item" title={t("Modifier")}>
                <Link
                  to={`/collaborateurs-update/${articlesData.id}`}
                  className="text-success d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li>
              <li className="list-inline-item" title={t("Supprimer")}>
                <Link
                  to="#"
                  className="text-danger d-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    onClickDelete(articlesData);
                  }}
                >
                  <i className="ri-delete-bin-5-line align-middle text-danger"></i>
                </Link>
              </li>
            </>
          );
        },
      },
    ],
    [t]
  );

  const errorMessage =
    typeof error === "string" ? error : error?.message || "Erreur";

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCollaborator}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={t("Liste des collaborateurs")}
          pageTitle={t("Liste des collaborateurs")}
        />

        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {isLoading ? (
                    <Loader />
                  ) : error ? (
                    <Loader error={errorMessage} />
                  ) : collaborateurs ? (
                    <div>
                      <TableContainer
                        columns={columns}
                        data={collaborateurs || []}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        divClass="table-responsive mb-1"
                        tableClass="mb-0 align-middle table-borderless"
                        theadClass="table-light text-muted"
                        isCollaborateurFilter={true}
                      />
                    </div>
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

Collaborateurs.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Collaborateurs));
